import type { CommunitySwitcher } from "@circle-react/types/CommunitySwitcher";
import { SortableList } from "@circle-react-shared/uikit/SortableList";
import { CommunitySection } from "./CommunitySection";

export interface SortableCommunityItemProps {
  community: CommunitySwitcher;
  index: number;
  isReorderingCommunities: boolean;
  sortedCommunities: CommunitySwitcher[];
  token: string;
}

export const SortableCommunityItem = ({
  community,
  sortedCommunities = [],
  isReorderingCommunities,
  token,
  index,
}: SortableCommunityItemProps) => (
  <SortableList.Item
    className="min-w-min"
    key={community.id}
    item={community}
    index={index}
    tabIndex={-1}
    disabled={isReorderingCommunities || sortedCommunities.length === 1}
  >
    <CommunitySection community={community} token={token} index={index} />
  </SortableList.Item>
);
